<script>
import vSelect from 'vue-select'
import PrefixesMixin from '@/mixins/prefixes.js'
import _ from 'lodash'

export default {
  name: 'PhonePrefixSelect',
  mixins: [PrefixesMixin],
  data: function () {
    return {
      phonePrefix: '+48',
      prefixesParsed: [],
    }
  },
  mounted() {
    this.changeTypeToNumber()
    this.prefixesParsed = _.uniq(this.prefixes.map(p => `+${p.value}`))
  },
  methods: {
    userSelected(prefix) {
      this.$emit('prefixSelected', prefix)
    },
    changeTypeToNumber() {
      // INFO: We change type of input on the fly, but there is difference comparing to `phone` input, we call `children[1]` in this case. It's because this input starts already selected.
      this.$refs.prefix.$el.children[0].children[0].children[1].type = 'number'
    },
  },
  components: { vSelect },
}
</script>

<template lang="pug">
.prefix
  v-select(
    ref="prefix"
    :clearable="false"
    :options="prefixesParsed"
    v-model="phonePrefix"
    @input="$emit('prefixSelected', $event)"
    @search:focus="$slideUp(30)"
    placeholder="Prefix"
  )
    span(slot="no-options") {{ $t('noSearchResults') }}
</template>

<style lang="scss">
.prefix {
  .vs--searchable .vs__dropdown-toggle {
    width: 8rem;
    border-radius: 9px 0rem 0rem 9px;
    padding: 5px 0 0.5rem 0;
    height: 54px;
    width: 60px;
  }
  .vs__actions {
    display: none;
  }
  .vs__search,
  .vs__search:focus {
    padding: 0 1rem 0 1rem;
  }
  .vs__search {
    position: absolute;
    top: 0px;
  }
  .vs__search:focus {
    position: relative;
  }
  .vs--searchable .vs__dropdown-toggle:after {
    content: '';
    width: 1px;
    background: black;
    position: absolute;
    right: 0px;
    top: 20%;
    height: 60%;
  }
  .vs__dropdown-menu {
    max-height: 16rem !important; // overriding $vs-dropdown-max-height
  }
}
</style>
